import React from 'react';
import Alert from './Alert';
import classNames from 'classnames';
import {INFO__24} from '@homeaway/svg-defs';

function AlertInfo(props) {
    let buttonClasses = classNames('Alert--info', props.className);
    return (
        <Alert
            {...props}
            className={buttonClasses}
            flairClassName="bg--color-action bg--color-info"
            svgClassName="text-info"
        />
    );
}

AlertInfo.propTypes = {
    ...Alert.propTypes
};

AlertInfo.defaultProps = {
    ...Alert.defaultProps,
    svgMarkup: INFO__24
};

export default AlertInfo;
